import apiCall from "./apiCall";

export type RefData = {
    id: string,
    name: string,
};

const getDataRef = async (type: string) => {
    const URL = `/RefData/GetDataRef?type=${type}`;
    return apiCall('get', URL);
};

const getDataRefRequestor = async (type: string) => {
    const URL = `/RefData/GetDataRefSire?type=${type}`;
    return apiCall('get', URL);
};

const putDataRef = async (data: any) => {
    const URL = '/RefData/Update';
    return apiCall('post', URL, data);
};

const postDataRef = async (data: any) => {
    const URL = '/RefData/Create';
    return apiCall('post', URL, data);
};

export {
    getDataRef,
    getDataRefRequestor,
    putDataRef,
    postDataRef
};
